<template>
    <div>
      <div class="modal hide fade" id="modalAssetList" tabindex="-1" role="dialog" aria-labelledby="modalAssetList" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                Unit List
              </h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-3" v-for="(i, index) in filterData" :key="index">
                        <div class="card" style="border: 1px solid #ccc; cursor: pointer;" @click="selectAsset(index)" data-dismiss="modal" v-if="i.condition === 'ready'">
                            <div class="card-body">
                                <div class="row">
                                    <img :src="`${publicPath}asset/img/product.png`" alt="" v-if="i.picture === null">
                                    <img :src="i.picture + '?size=thumbnail'"/>
                                </div>
                                <span><b>{{ i.asset_name }}</b></span>&nbsp; &nbsp;<span>{{ i.internal_number }}</span>
                                &nbsp;
                                <span class="badge badge-success" v-if="i.condition === 'ready'">{{ i.condition }}</span>
                                <span class="badge badge-danger" v-else>{{ i.condition }}</span>
                            </div>
                        </div>
                        <!-- Condition not ready -->
                        <div class="card" style="border: 1px solid #ccc; cursor: pointer;" @click="selectAsset(index)" data-dismiss="modal" v-else>
                            <div class="card-body">
                                <div class="row">
                                    <img :src="`${publicPath}asset/img/product.png`" alt="" v-if="i.picture === null">
                                    <img :src="i.picture + '?size=thumbnail'"/>
                                </div>
                                <span><b>{{ i.asset_name }}</b></span>&nbsp; &nbsp;<span>{{ i.internal_number }}</span>
                                &nbsp;
                                <span class="badge badge-success" v-if="i.condition === 'ready'">{{ i.condition }}</span>
                                <span class="badge badge-danger" v-else>{{ i.condition }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <pre>{{ assetList }}</pre> -->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AssetModal',
  computed: {
    ...mapState({
      assetList: state => state.assets.assetList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      return this.assetList.filter(d => {
        for (var name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      dataRaw: [],
      filterCategory: [],
      filterType: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  methods: {
    selectAsset (index) {
      var asset = this.assetList[index]
      this.$emit('selectAsset', asset)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    }
  }
}
</script>
